import { Category, GQL_ID } from '@@types'
import { gql, useQuery } from '@apollo/client'

type CategoriesBranchVariables = {
  shopId: GQL_ID
  parentId?: GQL_ID
}

type CategoriesBranchData = {
  categoriesBranch: Category[]
}

export const GQL_QUERY_CATEGORIES_BRANCH = gql`
  query categoriesBranch ($shopId: ID!, $parentId: ID) {
    categoriesBranch(shop_id: $shopId, parent_id: $parentId) {
      id
      name
      slug
      icon {
        url
      }
      altIcon {
        url
      }
      miniIcon {
        url
      }
      childrens {
        id
        name
        slug
        icon {
          url
        }
        altIcon {
          url
        }
        miniIcon {
          url
        }
      }
    }
  }
`

export const useCategoriesBranch = (variables: CategoriesBranchVariables) => {
  const { data, loading, error, refetch } = useQuery<
    CategoriesBranchData,
    CategoriesBranchVariables
  >(GQL_QUERY_CATEGORIES_BRANCH, {
    variables,
    fetchPolicy: 'cache-first',
    skip: !variables.shopId
  })

  const categoriesBranch = data?.categoriesBranch ?? []

  return {
    categoriesBranch,
    data,
    loading,
    error,
    refetch
  }
}
